export default "__VITE_ASSET__mDHtRIs$__"